var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "bg-FF fixed width-100 z-99" },
      [
        _c("van-search", {
          attrs: {
            placeholder: "搜索员工姓名",
            readonly: "",
            shape: "round",
            "show-action": "",
          },
          on: { click: _vm.openDeptUserTree },
          scopedSlots: _vm._u([
            {
              key: "action",
              fn: function () {
                return [
                  _c(
                    "div",
                    {
                      staticClass:
                        "w-110 h-66 l-h-66 bg-FFDA3E b-r-40 text-center",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.onSearch.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v("搜索")]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
          model: {
            value: _vm.queryParams.userName,
            callback: function ($$v) {
              _vm.$set(_vm.queryParams, "userName", $$v)
            },
            expression: "queryParams.userName",
          },
        }),
        _c(
          "div",
          {
            staticClass:
              "flex row-between col-center p-l-16 p-r-16 p-t-10 p-b-12 font-28 cor-66",
          },
          [
            _c(
              "div",
              {
                on: {
                  click: function ($event) {
                    return _vm.isShowTimePopup()
                  },
                },
              },
              [
                _vm._v(" 筛选时间 "),
                _c("van-icon", {
                  staticClass: "m-l-6",
                  staticStyle: { transform: "rotate(90deg)" },
                  attrs: { name: "play" },
                }),
              ],
              1
            ),
            _c("div", [_vm._v(_vm._s(_vm.sxsjLabel))]),
            [
              _c(
                "van-popup",
                {
                  attrs: { position: "bottom" },
                  model: {
                    value: _vm.sxsj.show,
                    callback: function ($$v) {
                      _vm.$set(_vm.sxsj, "show", $$v)
                    },
                    expression: "sxsj.show",
                  },
                },
                [
                  _c(
                    "van-tabs",
                    {
                      model: {
                        value: _vm.sxsj.active,
                        callback: function ($$v) {
                          _vm.$set(_vm.sxsj, "active", $$v)
                        },
                        expression: "sxsj.active",
                      },
                    },
                    [
                      _c(
                        "van-tab",
                        { attrs: { title: "开始时间" } },
                        [
                          _c("van-datetime-picker", {
                            attrs: {
                              formatter: _vm.formatter,
                              "show-toolbar": false,
                              title: "选择年月",
                              type: "year-month",
                            },
                            model: {
                              value: _vm.queryParams.startTime,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryParams, "startTime", $$v)
                              },
                              expression: "queryParams.startTime",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "van-tab",
                        { attrs: { title: "结束时间" } },
                        [
                          _c("van-datetime-picker", {
                            attrs: {
                              formatter: _vm.formatter,
                              "show-toolbar": false,
                              title: "选择年月",
                              type: "year-month",
                            },
                            model: {
                              value: _vm.queryParams.endTime,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryParams, "endTime", $$v)
                              },
                              expression: "queryParams.endTime",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "m-t-70 m-b-50 text-center" },
                    [
                      _c(
                        "van-button",
                        {
                          staticClass: "m-20 b-r-8",
                          attrs: { type: "default" },
                          on: {
                            click: function ($event) {
                              _vm.sxsj.show = false
                            },
                          },
                        },
                        [_vm._v("取 消")]
                      ),
                      _c(
                        "van-button",
                        {
                          staticClass: "m-20 b-r-8",
                          attrs: { type: "primary" },
                          on: { click: _vm.sxsjConfirm },
                        },
                        [_vm._v("确 定")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
          ],
          2
        ),
        _c("DeptUserTree", {
          ref: "deptUserTreeRef",
          attrs: { "show-checkbox": false },
          on: { deptUserTreeSubmit: _vm.deptUserTreeSubmit },
        }),
      ],
      1
    ),
    _c("div", { staticClass: "p-l-20 p-r-20 p-b-20 p-t-180" }, [
      _c("div", { staticClass: "staff-info width-100 p-20" }, [
        _c("div", { staticClass: "flex col-center m-b-24" }, [
          _c("img", {
            staticClass: "w-120 h-120 m-r-18",
            attrs: {
              src: _vm.userInfo.employeeImage
                ? _vm.userInfo.employeeImage
                : _vm.defaultImg,
              alt: "",
            },
          }),
          _c("div", { staticClass: "width-80" }, [
            _c("div", { staticClass: "flex col-center m-b-20 width-100" }, [
              _c(
                "span",
                { staticClass: "font-32 dis-in-b font-weight-600 m-r-10" },
                [_vm._v(_vm._s(_vm.userInfo.nickName))]
              ),
              _c(
                "span",
                { staticClass: "font-28 dis-in-b width-55 ellipsis-1" },
                [_vm._v(_vm._s(_vm.userInfo.postNames))]
              ),
            ]),
            _c("div", { staticClass: "font-28" }, [
              _c(
                "span",
                {
                  staticClass: "p-14 b-r-40 m-r-18",
                  staticStyle: { border: "1px solid #FFFFFF" },
                },
                [_vm._v("司龄:" + _vm._s(_vm.userInfo.entryYears))]
              ),
              _vm.userInfo.entryTime
                ? _c(
                    "span",
                    {
                      staticClass: "p-14 b-r-40",
                      staticStyle: { border: "1px solid #FFFFFF" },
                    },
                    [
                      _vm._v(
                        "入职: " +
                          _vm._s(
                            _vm
                              .moment(_vm.userInfo.entryTime)
                              .format("YYYY年MM月DD日")
                          )
                      ),
                    ]
                  )
                : _vm._e(),
            ]),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "p-12 bg-D3DBFF flex row-around col-center b-r-8" },
          _vm._l(_vm.tabs, function (item, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "font-28 p-t-8 p-b-8 p-l-18 p-r-18 cor-99",
                class: { active: _vm.activeIndex === index },
                on: {
                  click: function ($event) {
                    return _vm.selectTab(index)
                  },
                },
              },
              [_vm._v(_vm._s(item.title))]
            )
          }),
          0
        ),
      ]),
      _c("div", { staticClass: "h-12" }),
      _c("div", { staticClass: "tab-content" }, [
        _c(
          "div",
          { staticClass: "slide-transition" },
          [
            _vm.activeIndex === 0
              ? _c("CoreMessage", {
                  attrs: { boardData: _vm.coreInfo, roleType: _vm.roleType },
                })
              : _vm._e(),
            _vm.activeIndex === 1
              ? _c("WorkEfficiency", {
                  attrs: { boardData: _vm.workInfo, roleType: _vm.roleType },
                })
              : _vm._e(),
            _vm.activeIndex === 2 && _vm.roleType != 13
              ? _c("BusinessPerformance", {
                  attrs: {
                    boardData: _vm.businessInfo,
                    roleType: _vm.roleType,
                  },
                })
              : _vm._e(),
            _vm.activeIndex === 2 && _vm.roleType == 13
              ? _c("WorkloadStatistics", {
                  attrs: {
                    boardData: _vm.workloadInfo,
                    roleType: _vm.roleType,
                  },
                })
              : _vm._e(),
            _vm.activeIndex === 3
              ? _c("SalaryPerformance", {
                  attrs: { boardData: _vm.salaryInfo, roleType: _vm.roleType },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }